/**
 * The "New in Lineage" banner on the tree list (PRD 11.1). Each release that has news gets a new id; dismissing
 * the banner saves that id on this device, so it stays hidden until the next release. Storage can be unavailable
 * (private browsing); then the banner shows again next visit, which is harmless.
 */
export const WHATS_NEW_ID = '2026-11-04';
const KEY = 'lineage.whatsNew';

type Store = Pick<Storage, 'getItem' | 'setItem'>;

function deviceStore(): Store | null {
  try {
    return localStorage;
  } catch {
    return null;
  }
}

export function whatsNewDismissed(store: Store | null = deviceStore(), id = WHATS_NEW_ID): boolean {
  try {
    return store?.getItem(KEY) === id;
  } catch {
    return false;
  }
}

export function dismissWhatsNew(store: Store | null = deviceStore(), id = WHATS_NEW_ID): void {
  try {
    store?.setItem(KEY, id);
  } catch {
    /* shown again next visit */
  }
}
